<h2 class="fw-light" [style]="'margin-top:40px; margin-bottom:20px'">
  {{ 'documentationTitle' | i18next }}
</h2>
<main class="main">
  <button
    class="main--btnContainer__btn btn add"
    [style]="'background-color: #2c2a29'"
    mat-button
    (click)="uploadDocuments()"
  >
    {{ 'addDocuments' | i18next }}
  </button>
  <div>
    <table mat-table [dataSource]="dataSource" class="table">
      <!-- Columna Obligatorio -->
      <ng-container matColumnDef="obligatorio">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'mandatory' | i18next }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.obligatorio ? ('yes' | i18next) : ('no' | i18next) }}
        </td>
      </ng-container>

      <!-- Columna Tipo Documento -->
      <ng-container matColumnDef="tipoDocumento">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'documentType' | i18next }}
        </th>
        <td mat-cell *matCellDef="let element">
          <div class="cell-content">
            {{ element.tipoDocumento | i18next }}
            <ng-container *ngIf="element.tipoDocumento === 'GDPR'">
              <button
                mat-button
                (click)="downloadGDPRDocument()"
                matTooltip="{{ 'downloadTemplateGDPR' | i18next }}"
              >
                <mat-icon
                  aria-hidden="false"
                  aria-label="Download"
                  fontIcon="file_download"
                ></mat-icon>
              </button>
            </ng-container>
          </div>
        </td>
      </ng-container>

      <!-- Columna Documento -->
      <ng-container matColumnDef="documento">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'documentationTableDescription' | i18next }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{
            element.documento
              ? element.documento
              : ('authStatusPending' | i18next)
          }}
        </td>
      </ng-container>

      <!-- Columna Eliminar doc -->
      <ng-container matColumnDef="eliminar">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'altDelete' | i18next }}
        </th>
        <td mat-cell *matCellDef="let element">
          <button
            class="button-delete"
            mat-button
            [disabled]="!element.documento"
            (click)="deleteDocument(element)"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <!-- <ng-container matColumnDef="descargar">
        <th mat-header-cell *matHeaderCellDef>{{ 'download' | i18next }}</th>
        <td mat-cell *matCellDef="let element">
          <button mat-button (click)="downloadDocument(element)">
            <mat-icon
              aria-hidden="false"
              aria-label="Download"
              fontIcon="download"
            ></mat-icon>
          </button>
        </td>
      </ng-container> -->

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <p style="font-style: italic">{{ 'textAdditionalDocCheck' | i18next }}</p>
  </div>
  <div class="main--btnContainer">
    <button
      class="main--btnContainer__btn btn confirm"
      mat-button
      [disabled]="isButtonDisabled()"
      [style]="getButtonStyle()"
      (click)="sendRequest()"
    >
      {{ 'buttonContinue' | i18next | uppercase }}
    </button>
    <button
      class="main--btnContainer__btn btn cancel"
      [style]="'background-color: #2c2a29'"
      mat-button
      (click)="backStep()"
    >
      {{ 'btnReturn' | i18next | uppercase }}
    </button>
  </div>
</main>
